import Typography from "@mui/material/Typography"
import Grid from "@mui/material/GridLegacy"
import dynamic from "next/dynamic"
const ContactOfficeDetails = dynamic(() => import("./ContactOfficeDetails"));
const ContactOfficeDepots = dynamic(() => import("./ContactOfficeDepots"));
import { count } from "../../config/helpers";
import { useTemplatePageContent } from "../Providers/TemplatePageContentContext";

const ContactInformation = (props) => {

    const { template_page_content } = useTemplatePageContent();
    const page_content = template_page_content;

    return (
        <>
            <Typography className="mb-4 mt-2">
                {page_content.trading_content?.content}
            </Typography>

            <Grid container>
                <Grid item xs={12} lg={6}>
                    <ContactOfficeDetails />

                </Grid>
                <Grid item xs={12} lg={6}>
                    {count(props.depots) > 0 && <ContactOfficeDepots {...props} />}
                </Grid>
            </Grid>
        </>
    )
}

export default ContactInformation